import { render } from "./FilterSummaryItem.vue?vue&type=template&id=0b60abda"
const script = {}

import "./FilterSummaryItem.vue?vue&type=style&index=0&id=0b60abda&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__